import { defineStore } from 'pinia';

let isSetup = false;

export const useCartStore = defineStore('cart', {

    state: () => ({
        timestamp: 0,
        list: []
    }),

    actions: {
        inCart(productId) {
            this.setup();
            return this.list.find(entry => entry.id == productId) != null;
        },

        change(productId, num) {
            this.setup();

            productId = parseInt(productId);
            num = parseInt(num);

            if (num > 0) {
                const index = this.list.findIndex(entry => entry.id == productId);

                if (index !== -1) {
                    this.list[index].num = num;
                } else {
                    this.list.push({
                        id: productId,
                        num: num
                    })
                }
            } else {
                this.list = this.list.filter(entry => entry.id != productId);
            }

            this.timestamp = Date.now();
            this.save();
        },

        save() {
            const data = {
                timestamp: this.timestamp,
                list: this.list
            }

            localStorage.setItem("cart", JSON.stringify(data));
        },

        load() {
            try {
                const data = JSON.parse(localStorage.getItem("cart") || "{}");

                if (data && data.timestamp && data.timestamp > this.timestamp) {
                    this.timestamp = data.timestamp;
                    this.list = data.list || [];
                }
            } catch(e) {
                console.warn("Cart load error", e);
            }
        },

        setup() {
            if (isSetup) {
                return;
            }

            isSetup = true;

            this.load();

            window.addEventListener("focus", () => {
                this.load();
            });
        }
    }
});